import React, { useEffect, useState } from "react";
import { HiOutlineBars3, HiOutlineChatBubbleLeftRight, HiOutlineShoppingCart } from "react-icons/hi2";
import { useDispatch, useSelector } from "react-redux";
import { rootAction } from "../redux/reducer/rootReducer";
import { Badge, FormControl, Menu, MenuItem, Select } from "@mui/material";
import { IoIosAddCircleOutline, IoIosArrowDown } from "react-icons/io";
import { useNavigate } from "react-router";
import { CalendarAPI } from "../api/CalendarAPI";
import clubLogoImg from "../assets/images/SportMingleLogoMark.png"
import defaultDP from "../assets/images/avatar-design.png";
import Timer from "../pages/reservation-payment/Timer";
import { clubShowsHeaderCart } from "../util/calendarAccess";
import {
  clearHoldRecord,
  formatHoldClock,
  startHoldFromTimerResponse,
} from "../util/reservationHoldTimer";
import { formatRoleLabel, isClubOwner, isClubStaff, isCoach, isGuest, isUser } from "../util/UserRoles";
import { setSelectedClub } from "../redux/reducer/userReducer";
import { CoachSchedulerAPI } from "../api/CoachSchedulerAPI";
import ThemeSwitcher from "./ThemeSwitcher";
import RoleTooltip from "./RoleTooltip";

const Header = () => {
  const userInfo = useSelector((store) => store.user.userInfo);
  const selectedClub = useSelector((store) => store.user.selectedClub);
  const isUpdateTotalSchedule = useSelector((store) => store.root.isUpdateTotalSchedule);
  const openSlideBar = useSelector((store) => store.root.openSlideBar);
  const isPaymentDoneForReservation = useSelector((store) => store.root.isPaymentDoneForReservation);
  const isCheckoutConfigChange = useSelector((store) => store.root.isCheckoutConfigChange);
  const holdDisplay = useSelector((store) => store.root.holdDisplay);
  const isTimerActive = useSelector((store) => store.root.isTimerActive);
  const holdAskExtra = useSelector((store) => store.root.holdAskExtra);
  const totalUnreadMessage = useSelector((store) => store.chat?.totalUnreadMessage ?? 0);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [totalPendingReservation, setTotalPendingReservation] = useState(0);
  const [accountMenuAnchor, setAccountMenuAnchor] = useState(null);

  useEffect(() => {
    if (clubShowsHeaderCart(selectedClub, userInfo) && userInfo.userId && selectedClub?.clubId) {
      getTotalPendingReservation();
      if (isPaymentDoneForReservation.type == 'created' || isPaymentDoneForReservation.type == 'deleted') {
        dispatch(rootAction.setReservationPaymentStatus(({
          status: false,
          type: 'init'
        })));
      }
    } else if ((isUser(userInfo) || isCoach(userInfo)) && userInfo.userId && selectedClub?.clubId && selectedClub?.calendarType !== 'RESERVATION_CALENDAR') {
      getTotalUnPaidSchedule();
    }
    isUpdateTotalSchedule && dispatch(rootAction.setIsUpdateTotalSchedule(false))
  }, [userInfo.userId, selectedClub?.clubId, isUpdateTotalSchedule,isPaymentDoneForReservation.type]);


  const getTotalUnPaidSchedule = async () => {
    const response = await CoachSchedulerAPI.findTotalUnPaidSchedule(userInfo.userId,selectedClub.clubId);
    setTotalPendingReservation(response.Data);
  }

  const getTotalPendingReservation = async () => {
    const response = await CalendarAPI.getTotalPendingReservation({
      userId: userInfo.userId,
      clubId: selectedClub.clubId
    });
    if (isPaymentDoneForReservation?.type === 'payment') {
      setTotalPendingReservation(0);
      clearHoldRecord(selectedClub.clubId, userInfo.userId);
      dispatch(rootAction.setIsTimerActive(false));
      dispatch(rootAction.setHoldAskExtra(false));
      dispatch(rootAction.setHoldDisplay(""));
    } else {
      setTotalPendingReservation(response.Data);
      paymentTimerDetails();
    }
  }

  useEffect(() => {
   isCheckoutConfigChange && dispatch(rootAction.setIsCheckoutConfigChange(false));
  }, [isCheckoutConfigChange])
  

  const paymentTimerDetails = async () => {
    try {
      const response = await CalendarAPI.getPaymentTimerDetails({ userId: userInfo?.userId, clubId: selectedClub.clubId });
      const hold = startHoldFromTimerResponse({
        reservations: response?.Data?.reservations || [],
        userId: userInfo?.userId,
        clubId: selectedClub.clubId,
      });
      dispatch(rootAction.setHoldCreatedDate(hold.createdDate || null));
      dispatch(rootAction.setHoldExtraGrantedAt(hold.extraGrantedAt || null));
      dispatch(rootAction.setHoldPhaseSeconds(hold.phaseSeconds || 60));
      dispatch(rootAction.setInitialTimer(hold.remaining || 0));
      dispatch(rootAction.setHoldDisplay(hold.active || hold.askExtra ? formatHoldClock(hold.remaining || 0) : ""));
      if (hold.expired) {
        await CalendarAPI.deleteReservationWhenNotPaid({
          userId: userInfo?.userId,
          clubId: selectedClub.clubId,
        });
        clearHoldRecord(selectedClub.clubId, userInfo?.userId);
        dispatch(rootAction.setReservationPaymentStatus({ status: true, type: 'deleted' }));
        dispatch(rootAction.setIsTimerActive(false));
        dispatch(rootAction.setHoldAskExtra(false));
        return;
      }
      dispatch(rootAction.setHoldAskExtra(Boolean(hold.askExtra)));
      dispatch(rootAction.setIsTimerActive(Boolean(hold.active) && !hold.askExtra));
    } catch (error) {
      dispatch(rootAction.setIsTimerActive(false));
    }
  }
  const handleSelectClub = async(val) => {
    if (val !== 'add') {
      const newClub = userInfo.clubs.filter((club) => club.clubId === val);
      dispatch(setSelectedClub(newClub[0]));
    }
  }
  const roleTooltip = (userInfo?.authorities || [])
    .map((role) => formatRoleLabel(role.roleName))
    .filter(Boolean)
    .join(", ");

  const handleProfileRoute = () => {
    if (!isUser(userInfo)) {
      navigate('/club-setup')
      dispatch(rootAction.setActiveTab({ clubProfile: true }));
    }
  }
  return (
    <div className='root-header-container' data-testid='root-header-container'>
      <div data-testid="root-header-body" className={openSlideBar ? 'root-header-body active' : 'root-header-body'}>
        <div className="sm-header-left">
          <div className='root-open-sidebar'>
            <HiOutlineBars3 onClick={() => { dispatch(rootAction.setOpenSlideBar(!openSlideBar)) }} className='root-open-sidebar-icon' data-testid="root-open-sidebar-icon" />
          </div>
        </div>
        <div data-testid="root_cart_clubname" className="root_cart_clubname sm-header-right">
          <ThemeSwitcher />
          <div className="header_club_info">
            <FormControl fullWidth
              className="seleted_club_dropdown"
            >
              <Select
                disabled={isCoach(userInfo) || isClubOwner(userInfo)}
                IconComponent={(isCoach(userInfo) || isClubOwner(userInfo)) ? () => <></> : IoIosArrowDown}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={selectedClub?.clubId}
                size="small"
                MenuProps={{
                  disableScrollLock: true,
                }}
                onChange={(val) => handleSelectClub(val.target.value)}
              >
                {
                  userInfo?.clubs?.map((club, index) =>
                    <MenuItem sx={{
                      '&.Mui-selected': {
                        backgroundColor: 'var(--hoverColorLightest)',
                      },
                      '&.Mui-selected:hover': {
                        backgroundColor: 'var(--hoverColorLight)',
                      },
                    }} key={index} value={club?.clubId}>
                      <div className='header_club_info_item'>
                        <img src={club?.clubLogo ? `${import.meta.env.VITE_APP_BASE_URL}/club/club-logo-img/${club?.clubLogo}` : clubLogoImg} alt="" />
                        <h2 data-testid="club_name" >{club?.clubName}</h2>
                      </div>
                    </MenuItem>
                  )
                }
                <MenuItem value="add">
                  <div className='header_club_info_add_club' onClick={() => navigate("/add-org")}>
                    <IoIosAddCircleOutline className="header_club_info_add_club_icon" />
                    <p>Add Organization</p>
                  </div>
                </MenuItem>
              </Select>
            </FormControl>
          </div>
         {!isGuest(userInfo) &&
           <button type="button" className="sm-header-icon-btn" onClick={() => navigate("/chat")} aria-label="Chat">
             <Badge badgeContent={totalUnreadMessage} color="error" >
               <HiOutlineChatBubbleLeftRight className="sm_header_chat_icon" />
             </Badge>
           </button>}
          {clubShowsHeaderCart(selectedClub, userInfo) &&
            <div
              data-testid="cart-container"
              onClick={() =>{
                if (selectedClub?.calendarType === 'RESERVATION_CALENDAR'){
                  navigate('/cart');
                }else{
                  navigate('/schedule-cart');
                }
              
              }}
              className="root_header_cart_conatiner">
              <Timer />
              <Badge
                className="cart-hold-badge"
                overlap="circular"
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                badgeContent={(isTimerActive || holdAskExtra) && holdDisplay ? holdDisplay : totalPendingReservation}
                color="error"
              >
                <HiOutlineShoppingCart className="root_cart_icon" />
              </Badge>
            </div>
          }
          {userInfo?.firstName && (
            <>
              <button
                type="button"
                className="sm-header-user"
                aria-haspopup="true"
                aria-expanded={Boolean(accountMenuAnchor)}
                data-testid="header-account-menu"
                onClick={(event) => setAccountMenuAnchor(event.currentTarget)}
              >
                <RoleTooltip title={roleTooltip} placement="bottom" disabled={Boolean(accountMenuAnchor)}>
                  <span className="sm-header-user-avatar" data-testid="header-user-avatar">
                    <img
                      src={userInfo?.profileImage ? `${import.meta.env.VITE_APP_BASE_URL}/user/user-profile-img/${userInfo.profileImage}` : defaultDP}
                      alt=""
                    />
                  </span>
                </RoleTooltip>
                <span>{userInfo.firstName}</span>
                <IoIosArrowDown />
              </button>
              <Menu
                anchorEl={accountMenuAnchor}
                open={Boolean(accountMenuAnchor)}
                onClose={() => setAccountMenuAnchor(null)}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                slotProps={{ paper: { className: "sm-header-account-menu" } }}
              >
                <MenuItem
                  data-testid="header-profile-link"
                  onClick={() => {
                    setAccountMenuAnchor(null);
                    navigate("/profile");
                    dispatch(rootAction.setActiveTab({ profile: true }));
                  }}
                >
                  Profile
                </MenuItem>
              </Menu>
            </>
          )}
        </div>
      </div>
    </div>
  )
};

export default Header;